/* Atelier theme JS: scrollers, tabs, product gallery, variant picker,
   quantity buttons, cart updates, recommendations. No dependencies. */

(function () {
  'use strict';

  function initScrollers(root) {
    root.querySelectorAll('[data-scroller]').forEach(function (scroller) {
      var track = scroller.querySelector('[data-scroller-track]');
      if (!track) return;
      var step = function () { return Math.max(track.clientWidth * 0.8, 240); };
      scroller.querySelectorAll('[data-scroll-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      });
      scroller.querySelectorAll('[data-scroll-next]').forEach(function (btn) {
        btn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-tabs]').forEach(function (section) {
      var buttons = section.querySelectorAll('[data-tab-button]');
      var panels = section.querySelectorAll('[data-tab-panel]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = btn.getAttribute('data-tab-button');
          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === index);
          });
        });
      });
    });
  }

  function initQuantity(root) {
    root.querySelectorAll('[data-quantity]').forEach(function (qty) {
      var input = qty.querySelector('input');
      if (!input) return;
      var change = function (delta) {
        var min = parseInt(input.min || '1', 10);
        var value = parseInt(input.value || '1', 10) + delta;
        if (value < min) value = min;
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      var minus = qty.querySelector('[data-qty-minus]');
      var plus = qty.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { change(-1); });
      if (plus) plus.addEventListener('click', function () { change(1); });
    });
  }

  function initCartQuantity(root) {
    root.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
  }

  function initProductGallery(section) {
    var mainImages = section.querySelectorAll('[data-main-media] [data-media-id]');
    var thumbs = section.querySelectorAll('[data-thumb]');
    if (!mainImages.length) return;

    section.showMedia = function (mediaId) {
      var found = false;
      mainImages.forEach(function (img) {
        var match = img.getAttribute('data-media-id') === String(mediaId);
        img.classList.toggle('is-hidden', !match);
        if (match) found = true;
      });
      if (!found) return;
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === String(mediaId));
      });
    };

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        section.showMedia(thumb.getAttribute('data-media-id'));
      });
    });
  }

  function moneyFormat(cents) {
    /* Uses a simple fallback format; Shopify renders exact prices on reload. */
    var amount = (cents / 100).toFixed(2);
    var el = document.querySelector('[data-atc-price], .price__current');
    var sample = el ? el.textContent.trim() : '';
    var symbol = (sample.match(/^[^\d\s]+/) || ['$'])[0];
    return symbol + amount;
  }

  function initVariantPicker(section) {
    var picker = section.querySelector('[data-variant-picker]');
    var jsonTag = section.querySelector('[data-product-json]');
    if (!picker || !jsonTag) return;

    var variants;
    try { variants = JSON.parse(jsonTag.textContent); } catch (e) { return; }

    var inputs = picker.querySelectorAll('[data-option-input]');

    function selectedOptions() {
      var options = [];
      picker.querySelectorAll('.variant-picker__option').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        options.push(checked ? checked.value : null);
      });
      return options;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return options.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      });
    }

    function update() {
      var options = selectedOptions();

      picker.querySelectorAll('.variant-picker__option').forEach(function (fieldset, i) {
        var label = fieldset.querySelector('[data-option-value-label]');
        if (label && options[i]) label.textContent = options[i];
      });

      var variant = findVariant(options);
      if (!variant) return;

      var idInput = section.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      var button = section.querySelector('[data-add-to-cart]');
      var text = section.querySelector('[data-atc-text]');
      if (button && text) {
        if (variant.available) {
          button.disabled = false;
          text.innerHTML = 'Add to cart &middot; ' + moneyFormat(variant.price);
        } else {
          button.disabled = true;
          text.textContent = 'Sold out';
        }
      }

      var priceWrapper = section.querySelector('[data-price-wrapper]');
      if (priceWrapper) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price price--large"><s class="price__compare">' + moneyFormat(variant.compare_at_price) + '</s> ';
          html += '<span class="price__current price__current--sale">' + moneyFormat(variant.price) + '</span></span>';
          var discount = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          html += '<span class="main-product__discount-badge">' + discount + '% off</span>';
        } else {
          html += '<span class="price price--large"><span class="price__current">' + moneyFormat(variant.price) + '</span></span>';
        }
        priceWrapper.innerHTML = html;
      }

      var stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = moneyFormat(variant.price);
      var stickyButton = section.querySelector('[data-sticky-button]');
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (variant.featured_media && section.showMedia) {
        section.showMedia(variant.featured_media.id);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  function initRecommendations(root) {
    root.querySelectorAll('[data-recommendations]').forEach(function (container) {
      var url = container.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            container.innerHTML = fresh.innerHTML;
            initScrollers(container);
          }
        })
        .catch(function () { /* leave empty on failure */ });
    });
  }

  function initOfferPicker(section) {
    var picker = section.querySelector('[data-offer-picker]');
    if (!picker) return;
    var qtyInputs = section.querySelectorAll('[data-offer-qty]');
    picker.querySelectorAll('[data-offer-input]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        qtyInputs.forEach(function (input) { input.value = radio.value; });
      });
    });
  }

  function initPurchaseOptions(section) {
    var options = section.querySelector('[data-purchase-options]');
    if (!options) return;
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    function apply() {
      var checked = options.querySelector('[data-plan-input]:checked');
      var existing = form.querySelector('input[name="selling_plan"]');
      if (checked && checked.value) {
        if (!existing) {
          existing = document.createElement('input');
          existing.type = 'hidden';
          existing.name = 'selling_plan';
          form.appendChild(existing);
        }
        existing.value = checked.value;
      } else if (existing) {
        existing.remove();
      }
    }
    options.querySelectorAll('[data-plan-input]').forEach(function (radio) {
      radio.addEventListener('change', apply);
    });
    apply();
  }

  function initStickyAtc(section) {
    var bar = section.querySelector('[data-sticky-atc]');
    var mainButton = section.querySelector('[data-add-to-cart]');
    if (!bar || !mainButton) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    });
    observer.observe(mainButton);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollers(document);
    initTabs(document);
    initQuantity(document);
    initCartQuantity(document);
    initRecommendations(document);
    document.querySelectorAll('[data-product]').forEach(function (section) {
      initProductGallery(section);
      initVariantPicker(section);
      initOfferPicker(section);
      initPurchaseOptions(section);
      initStickyAtc(section);
    });
  });
})();
